import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/packge_tag/gold.png')
const LOGO = assets.images.packgeTag.gold

const GoldPackageTag = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default GoldPackageTag
